module.exports = __webpack_public_path__ + "img/Volvo.a4b59ae2.png";